import { selectPostJobStep, selectSideBarShow, selectSideBarExpanded } from '../../store/workspace/selectors';
import { setSideBarShow } from '../../store/workspace/slice';
import { useDispatch, useSelector } from '../../store/store';
import { ReactNode, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './style.module.scss';
import SideBar from './SideBar';
import Header from './Header';

interface Props {
    children: ReactNode;
};

function WorkspaceLayout(props: Props) {
    const { children } = props;
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const ref = useRef<HTMLDivElement | null>(null);
    const postJobStep = useSelector(selectPostJobStep);
    const sideBarShow = useSelector(selectSideBarShow);
    const sideBarExpanded = useSelector(selectSideBarExpanded);

    useEffect(() => {
        ref.current?.scrollTo({ top: 0, behavior: 'smooth' });
    }, [pathname, postJobStep]);

    const handleClick = () => {
        if (!sideBarShow) return;
        dispatch(setSideBarShow(false));
    };

    return (
        <div
            className={styles.container}
            onClick={handleClick}
            data-sidebar-expanded={sideBarExpanded}
        >
            <Header />
            <SideBar show={sideBarShow} />
            <div ref={ref} className={styles.child}>
                {children}
            </div>
        </div>
    );
};

export default WorkspaceLayout;
